import { CAROUSEL_TYPE, POPOVER_ROLE } from 'consts/enum';
import { setCustomTagHTML } from 'helpers/helpers';
import cardImg from 'icons/cardImg.svg';
import { ENGT_CHAT } from 'js/bot.model';
import { Carousel } from 'ui/carousel/carousel.module';
import { launchCards } from './launchCards.model';
import { LaunchCardsTemplate } from './launchCards.template';

export default class LaunchCards {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData(propData) {
		this.data = launchCards;
		let cards = [];
		if (ENGT_CHAT.get('config.launchCards')?.length) {
			cards = ENGT_CHAT.get('config.launchCards').map(
				(
					{
						card_text,
						card_image,
						card_action_title,
						card_body_text,
						card_action_type,
						card_action_value,
						id,
						...rest
					},
					index
				) => ({
					title: card_text || '',
					subtitle: card_body_text || '',
					image: card_image || cardImg,
					imageAlt: '',
					gradient_bottom_color: '#ffffff',
					gradient_top_color: '#ffffff',
					buttons: card_action_title
						? [
								{
									title: card_action_title,
									type: card_action_type,
									value: card_action_value,
								},
						  ]
						: [],
					...rest,
				})
			);
		}

		this.setter({
			...propData,
			brandName: ` ${ENGT_CHAT.get('config.bot_name') || ENGT_CHAT.get('config.launchScreenHeader')}`,
			cards,
			exploreMore: ENGT_CHAT.get('GENERIC_STRINGS')?.['EXPLORE_MORE'] || 'Explore more on',
		});
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		const fragment = document.createDocumentFragment();

		wrapper.innerHTML = LaunchCardsTemplate(this.data);
		while (wrapper.firstChild) {
			fragment.appendChild(wrapper.firstChild);
		}

		this.html = fragment;
	}

	initComponents() {
		const { cards, type = CAROUSEL_TYPE.HORIZONTAL } = this.data;

		const carousel = new Carousel({
			cards,
			type,
			shouldWrap: false,
			popoverRole: POPOVER_ROLE.ELLIPSIS,
			ellipsis: {
				title: 2,
				description: 2,
			},
		});

		const carouselCards = carousel.render();

		if (type === CAROUSEL_TYPE.HORIZONTAL && carousel.dots) {
			setCustomTagHTML(this.html.querySelector('carousel-dots'), carousel.dots);
		}
		setCustomTagHTML(this.html.querySelector('carousel'), carouselCards);
	}

	initEventHandlers() {}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
